import { useEffect, useState } from "react";
import { Moon, Sun } from "lucide-react";

const apply = (theme) => {
  document.documentElement.classList.toggle("light", theme === "light");
};

export const initTheme = () => {
  const stored = localStorage.getItem("netsys-theme");
  const theme = stored || "dark"; // dark = modo principal de marca
  apply(theme);
  return theme;
};

export const ThemeSwitcher = () => {
  const [theme, setTheme] = useState("dark");
  useEffect(() => setTheme(initTheme()), []);

  const toggle = () => {
    const next = theme === "dark" ? "light" : "dark";
    setTheme(next);
    localStorage.setItem("netsys-theme", next);
    apply(next);
  };

  return (
    <button
      onClick={toggle}
      aria-label={theme === "dark" ? "Cambiar a modo claro" : "Cambiar a modo oscuro"}
      className="p-2 rounded-full border border-[var(--line)] text-[var(--muted)] hover:text-[var(--ink)] hover:border-[var(--cyan)]/50 transition-colors"
      data-testid="theme-switcher"
    >
      {theme === "dark" ? <Sun size={16} /> : <Moon size={16} />}
    </button>
  );
};
